import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { CoreServices } from "@/components/CoreServices";
import { WorkGallery } from "@/components/WorkGallery";
import { QuoteStrip } from "@/components/QuoteStrip";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  useEffect(() => {
    document.title = "SMS Electrical & Fiber Optic Installers | Powering Today. Connecting Tomorrow.";
    const link = document.querySelector("link[rel='canonical']");
    if (link) link.href = "https://smselectrical.com/";
  }, []);

  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <CoreServices />
        <WorkGallery />
        <QuoteStrip />
      </main>
      <Footer />
    </div>
  );
}
